
import { Component, Prop, Vue } from 'vue-property-decorator';
import Collapsible from "@/components/shared/Collapsible.vue";
import Dashboard from "@/components/overview/Dashboard.vue";
import KpiTrend from "@/components/overview/KpiTrend.vue";
import {IEvolution} from "@/shared/contracts/EvolutionContract";
import {IConsultantBarometerKPIResult} from "@/shared/contracts/KPIContract";

@Component({
  components: {KpiTrend, Dashboard, Collapsible}
})
export default class HiveDetailsHeader extends Vue {
  @Prop() kpi: IConsultantBarometerKPIResult;
  @Prop() evolution: IEvolution;

  protected showKpi = true;

}
